import script from "./Hotline.vue?vue&type=script&setup=true&lang=js"
export * from "./Hotline.vue?vue&type=script&setup=true&lang=js"

import "./Hotline.vue?vue&type=style&index=0&id=99a5043c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99a5043c"]])

export default __exports__